export function flattenNavItems(items = []) {
    return items.flatMap((item) => [
        item,
        ...(Array.isArray(item.children) ? flattenNavItems(item.children) : []),
    ]);
}

export function findNavItemByPath(items, pathname) {
    return flattenNavItems(items).find((item) => item.link === pathname);
}
